import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GdoWebviewRoutingModule } from './gdo-webview-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from 'src/app/shared/shared.module';
import { GdoVehicleDetailWebviewComponent } from './gdo-vehicle-detail-webview/gdo-vehicle-detail-webview.component';
import { GdoSubscriptionDetailWebviewComponent } from './gdo-vehicle-detail-webview/gdo-subscription-detail-webview/gdo-subscription-detail-webview.component';
import { GdoPurchaseSubscriptionWebviewComponent } from './gdo-purchase-subscription-webview/gdo-purchase-subscription-webview.component';
import { GdoVehicleModule } from "../gdo-desktop/gdo-vehicle/gdo-vehicle.module";
// import { GdoSubscriberContactInfoWebviewComponent } from './gdo-subscriber-contact-info-webview/gdo-subscriber-contact-info-webview.component';
import { GdoContactSubscriptionWebviewComponent } from './gdo-contact-subscription-webview/gdo-contact-subscription-webview.component';
import { GdoIntroductionVideoDialogComponentWebviewComponent } from './gdo-introduction-video-dialog-component-webview/gdo-introduction-video-dialog-component-webview.component';
import { GdoTermsOfUseWebviewComponent } from './gdo-terms-of-use-webview/gdo-terms-of-use-webview.component';
import { GdoBillingHistoryWebviewComponent } from './gdo-billing-history-webview/gdo-billing-history-webview.component';
// import { GdoAdvancedFilterationOptionsComponent } from './gdo-billing-history-webview/gdo-advanced-filteration-options/gdo-advanced-filteration-options.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { BillingCardsComponent } from './gdo-billing-history-webview/billing-cards/billing-cards.component';
import { GdoConnectedGarageFeaturesWebviewComponent } from './gdo-connected-garage-features-webview/gdo-connected-garage-features-webview.component';


@NgModule({
    declarations: [
        GdoVehicleDetailWebviewComponent,
        GdoSubscriptionDetailWebviewComponent,
        GdoPurchaseSubscriptionWebviewComponent,
        // GdoSubscriberContactInfoWebviewComponent
        GdoContactSubscriptionWebviewComponent,
        GdoIntroductionVideoDialogComponentWebviewComponent,
        GdoTermsOfUseWebviewComponent,
        GdoBillingHistoryWebviewComponent,
        // GdoAdvancedFilterationOptionsComponent,
        BillingCardsComponent,
        GdoConnectedGarageFeaturesWebviewComponent,
        
    ],
    exports: [GdoVehicleDetailWebviewComponent],
    imports: [
        GdoWebviewRoutingModule,
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatGridListModule,
        MatRadioModule,
        MatStepperModule,
        SharedModule,
        MatTabsModule,
        MatListModule,
        MatDatepickerModule,
        GdoVehicleModule,
        MatIconModule,
        MatCheckboxModule,
        MatTableModule
    ]
})
export class GdoWebviewModule { }
